import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { TermsModelType } from 'src_common/common/websocket2/modelsApi/Market';

/**
 * BE can send offered:true with places:1 and reduction "1/1" (win-only).
 * That is not a meaningful each-way offer and must be treated as unavailable on FE.
 */
export const isMeaningfulEachWayTerms = (terms: TermsModelType | undefined): boolean => {
    if (terms === undefined) {
        return false;
    }

    if (terms.places === 1 && terms.reduction === '1/1') {
        return false;
    }

    return true;
};

export const isEachWayOffered = (market: MarketModel | null | undefined): boolean => {
    if (market === null || market === undefined) {
        return false;
    }

    return market.eachWayOffered && isMeaningfulEachWayTerms(market.eachWay?.terms[0]);
};
